import React, { useCallback, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { closeAccordion } from 'ducks/accordions'
import { updateTable } from 'ducks/apps/datasources'
import {
  fieldPolicy,
  setPoliciesOnTable,
  updatePolicy,
} from 'utils/permissions'
import Modal from 'components/Shared/Modal'

import ModalHeader from './ModalHeader'
import InfoBanner from './InfoBanner'
import ButtonBar from './ButtonBar'
import UserPropertiesList from './UserPropertiesList'

import './UserPermissionsModal.scss'

const BETA_URL =
  'https://help.adalo.com/database/user-collection-permissions#beta'

const LEARN_MORE_URL =
  'https://help.adalo.com/database/user-collection-permissions'

const PROPERTIES_ACCORDION_GROUP = 'permissions-properties'

export function ModalComponent({
  table,
  policies,
  isUsersTable,
  enableSave,
  unsavedFields,
  onPolicyChange,
  onSaveClick,
  onCancelClick,
}) {
  return (
    <div className="permissions-modal">
      <ModalHeader
        title={`${table.name} Permissions`}
        betaUrl={BETA_URL}
        onBackClick={onCancelClick}
      />
      <Modal.Content>
        <InfoBanner learnMoreUrl={LEARN_MORE_URL} />
        <UserPropertiesList
          table={table}
          policies={policies}
          isUsersTable={isUsersTable}
          unsavedFields={unsavedFields}
          accordionGroup={PROPERTIES_ACCORDION_GROUP}
          displayBadges
          onPolicyChange={onPolicyChange}
        />
      </Modal.Content>
      <ButtonBar
        enableSave={enableSave}
        footnote="* Relationship properties are not affected by Permissions"
        onSaveClick={onSaveClick}
        onCancelClick={onCancelClick}
      />
    </div>
  )
}

function Container({
  appId,
  datasourceId,
  history,
  datasource,
  table,
  updateTable,
  closeAccordion,
}) {
  const { tableId } = table
  const isUsersTable = datasource.auth?.table === tableId

  const [policies, setPolicies] = useState(table.policies || [])
  const [dirtyFields, setDirtyFields] = useState([])

  const handlePolicyChanged = useCallback(
    (fieldId, action, allowed) => {
      const newPolicy = fieldPolicy(fieldId, action, allowed)
      const updated = updatePolicy(policies, newPolicy)
      setPolicies(updated)
      setDirtyFields([...dirtyFields, fieldId])
    },
    [policies]
  )

  const closeModal = useCallback(() => {
    const baseURL = `/apps/${appId}/data/${datasourceId}/${tableId}`

    const result = history.push(baseURL)

    closeAccordion(PROPERTIES_ACCORDION_GROUP)

    return result
  }, [appId, datasourceId, tableId, history, policies, closeAccordion])

  const handleSave = useCallback(() => {
    const updatedTable = setPoliciesOnTable(table, policies)
    updateTable(appId, datasourceId, tableId, updatedTable)
    setDirtyFields([])

    closeModal()
  }, [appId, datasourceId, tableId, table, history, policies, closeModal])

  const handleCancel = useCallback(() => {
    closeModal()
  }, [closeModal])

  return (
    <ModalComponent
      table={table}
      policies={policies}
      isUsersTable={isUsersTable}
      enableSave={dirtyFields.length > 0}
      unsavedFields={dirtyFields}
      onPolicyChange={handlePolicyChanged}
      onSaveClick={handleSave}
      onCancelClick={handleCancel}
    />
  )
}

const mapStateToProps = () => ({})

const mapDispatchToProps = {
  updateTable,
  closeAccordion,
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Container)
)
